import { Button } from "@/components/ui/button";

export default function Pagination({ page, limit, total, onPage, label = "itens", testid = "pager" }) {
  if (!total || total <= limit) return null;
  const pages = Math.ceil(total / limit);
  return (
    <div className="flex items-center justify-between" data-testid={`${testid}`}>
      <span className="text-sm text-muted-foreground">{total} {label} · pág. {page}/{pages}</span>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`${testid}-prev`}>Anterior</Button>
        <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid={`${testid}-next`}>Próxima</Button>
      </div>
    </div>
  );
}
